import { Auditable, FormEntity, QueryParams, SortParams } from "..";

export interface FormCategory extends Auditable {
    name: string;
    tenantId: number;

    forms?: FormEntity[];
}

export const DefaultFormCategoryQueryParams: QueryParams = {
    name: "",
};

export const DefaultFormCategorySortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};

export enum FormCategories {
    Referral = "Referral",
    Recovery = "Recovery",
    MedicalChartReview = "Medical Chart Review",
    Distribution = "Distribution",
    QualityAssurance = "Quality Assurance"
}
